export default "__VITE_ASSET__D3lNaZ7F__"